var _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAmericanExpress = function SvgAmericanExpress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 25,
    rx: 4.5,
    fill: "#F8F8F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#american-express_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.789 8.417.576-1.566H26V4H8v18h18v-2.844h-2.484l-.918-1.073-.954 1.073h-7.056v-5.717h-2.33l2.913-6.588h2.833l.684 1.494V6.851h3.518l.586 1.566h-.003Zm-1.987 1.037-.008-.63.242.63 1.17 3.125h1.162l1.178-3.125.226-.623v3.751h1.224V7.784h-2.034l-.925 2.437-.245.659-.252-.66-.928-2.436h-2.034v4.798h1.224V9.454Zm-2.636 3.125h1.412L17.464 7.78h-1.638l-2.124 4.799h1.394l.37-.925h2.33l.37.925Zm-1.774-3.175.24-.602.242.602.497 1.213h-1.476l.497-1.213Zm-.821 4.039v4.78h4.007v-1.036h-2.783v-.835h2.729v-1.034h-2.73v-.838h2.784v-1.037H15.57Zm8.467 4.78h1.591l-2.243-2.4 2.243-2.384h-1.566l-1.447 1.555-1.44-1.555h-1.595l2.24 2.401-2.24 2.384h1.548l1.458-1.56 1.451 1.56Zm.605-2.404L26 17.198v-2.744l-1.357 1.361v.004Z",
    fill: "#006FCF"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 25,
    rx: 4.5,
    stroke: "#7F939D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "american-express_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 4)",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgAmericanExpress;